<template lang='pug'>
    v-breadcrumbs.px-4( :items='items' )
</template>

<script>
    //
    import { VBreadcrumbs } from "vuetify/lib"
    //
    export default {
        name: "r-router-breadcrumbs",
        components: {
            VBreadcrumbs,
        },
        data () {
            return {
                items: []
            }
        },
        methods: {

            /**
             * 
             */
            filterHasMeta ( match ) {
                return (
                    match.hasOwnProperty( 'meta' ) &&
                    match.meta.hasOwnProperty( 'title' )
                )
            },

            /**
             * 
             */
            mapMatchToItem ( match ) {
                return {
                    disabled: match.regex.test( location.hash.replace('#','') ),
                    exact   : true,
                    text    : match.meta.title || '',
                    to      : match.path,
                }
            },

            /**
             * 
             */
            fetchItems () {
                this.items = [
                    {
                        exact   : true,
                        text    : this.indexText,
                        to      : '/',
                    },
                    ...this.$route.matched.filter( this.filterHasMeta ).map( this.mapMatchToItem ),
                ]
            },
        },
        mounted () {
            this.fetchItems()
        },
        props: {

            /**
             * 
             */
            indexText: String,
        },
        watch: {

            /**
             * 
             */
            $route () {
                this.fetchItems()
            },
        },
    }
</script>
